export { default } from './GenderIcon';

